module.exports = __webpack_public_path__ + "img/logo-text-small.7218f941.svg";